import { useContext } from 'react';
import { AlgoliaAppContext } from '../contexts/App.context';
export const useAlgoliaAppContext = () => useContext(AlgoliaAppContext);
